export { HouseholdAccessJustificationPageTemplate as default } from './HouseholdAccessJustificationPageTemplate';
